import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progressbar',
  template: `
<div class="row pb-3">

  <div class="col-12 pb-2 small">
    <span class="pr-2 text-nowrap">
      <span class="text-danger"><fa name="circle"></fa></span>
      <span class="text-nowrap">{{ approvedKey }}</span>
      <b class="text-nowrap d-inline-block pb-1">{{ approvedAmount | cad_currency }}</b>
    </span>

    <br class="d-block d-sm-none" />

    <span class="pr-2 text-nowrap">
      <span class="text-warning"><fa name="circle"></fa></span>
      <span class="text-nowrap">{{ pendingKey }}</span>
      <b class="text-nowrap d-inline-block pb-1">{{ pendingAmount | cad_currency }}</b>
    </span>

    <br class="d-block d-sm-none" />

    <span class="pr-2 text-nowrap">
      <span class="text-success"><fa name="circle"></fa></span>
      <span class="text-nowrap">{{ availableKey }}</span>
      <b class="text-nowrap d-inline-block pb-1">{{ availableAmount | cad_currency }}</b>
    </span>
  </div>

  <div class='col-12'>
    <div class="progress text-center">
      <div *ngIf="approvedAmount"
        class="progress-bar bg-danger" role="progressbar" [style.width.%]="approvedAmountPercentage"
        aria-valuenow="" aria-valuemin="" aria-valuemax="">
      </div>
      <div *ngIf="pendingAmount"
        class="progress-bar bg-warning" role="progressbar" [style.width.%]="pendingAmountPercentage"
        aria-valuenow="" aria-valuemin="" aria-valuemax="">
      </div>
      <div *ngIf="availableAmount"
        class="progress-bar bg-success" role="progressbar" [style.width.%]="availableAmountPercentage"
        aria-valuenow="" aria-valuemin="" aria-valuemax="">
      </div>
    </div>
  </div>

</div>
`,
  styles: [`.barprice { z-index: 1; position: absolute; }`],
})
export class ProgressbarComponent {
  @Input() pendingKey: string;
  @Input() approvedKey: string;
  @Input() availableKey: string;
  @Input() pendingAmount: number;
  @Input() approvedAmount: number;
  @Input() availableAmount: number;
  @Input() pendingAmountPercentage: number;
  @Input() approvedAmountPercentage: number;
  @Input() availableAmountPercentage: number;
  @Input() totalAmount: number;
}



// WEBPACK FOOTER //
// ./src/app/global/progressbar.component.ts